export default [
    {
        path: 'usuarios/',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'UsuarioController' }
    }, {
        path: 'usuario/add',
        component: require('./Add').default,
        meta: { middleware: 'auth', controller: 'UsuarioController' }
    }, {
        path: 'usuario/edit/:id',
        component: require('./Edit').default,
        meta: { middleware: 'auth', controller: 'UsuarioController' }
    },
    {
        path: 'relatorios/usuarios',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/usuarios/home',
        meta: { middleware: 'auth', controller: 'UsuarioController' },
        children: [
            {
                path: 'home',
                name: "relatorios_home_usuarios",
                component: require('./reports/includes/Home').default,
                meta: { middleware: 'auth', controller: 'UsuarioController' },
            },
            {
                path: 'graficos',
                name: "graficos_usuarios",
                component: require('./reports/includes/Graficos').default,
                meta: { middleware: 'auth', controller: 'UsuarioController' },
            },

        ]
    },
    {
        path: 'usuarios/imprimir/:id',
        component: require('./includes/pages/Impressao').default,
        meta: { middleware: 'auth', controller: 'UsuarioController' }
    },
];
